module.exports = __webpack_public_path__ + "img/logobg1.980e4369.jpg";